import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCommon } from "@obg/common.config";
import { Jurisdiction } from "@obg/ngx.core";
import { ConfigService } from "@obg/ngx.global";

import { LoyaltyExchangePointsLimits } from "./loyalty.model";

@Injectable({
	providedIn: "root",
})
export class LoyaltyConfigService {
	constructor(private configService: ConfigService<ObgConfigFeAdaptiveClientCommon>) {}

	isEnabled(): boolean {
		return this.configService.get((x) => x.common.loyalty.enabled, false);
	}
	getBalanceEndpoint(): string {
		return this.configService.get(
			(x) => x.common.loyalty.endpoints!.balance,
			"v1/current-customer-loyalty/balance-overview"
		);
	}
	getHistoryEndpoint(): string {
		return this.configService.get(
			(x) => x.common.loyalty.endpoints!.history,
			"v1/current-customer-loyalty/redeemables-history"
		);
	}
	getMonthlyHistoryEndpoint(): string {
		return this.configService.get(
			(x) => x.common.loyalty.endpoints!.history,
			"v1/current-customer-loyalty/monthly-history"
		);
	}
	getExchangePointsEndpoint(): string {
		return this.configService.get(
			(x) => x.common.loyalty.endpoints!.exchangePoints,
			"v1/current-customer-loyalty/exchange-points"
		);
	}
	getBrandLoyaltyLevelsEndpoint(): string {
		return this.configService.get((x) => x.common.loyalty.endpoints!.exchangePoints, "v1/brand-loyalty-levels");
	}

	exchangePointsLimits(): LoyaltyExchangePointsLimits {
		return this.configService.get((x) => x.common.loyalty.exchangePointsLimits);
	}
	historyPageSize(): number {
		return this.configService.get((x) => x.common.loyalty.historyPageSize, 10);
	}

	getBlockedJurisdictions(): Jurisdiction[] {
		return this.configService.get((x) => x.common.loyalty.blockedJurisdictions, []) as Jurisdiction[];
	}

	getBlockedCountries(): string[] {
		return this.configService.get((x) => x.common.loyalty.blockedCountries, []);
	}

	getTermsAndConditionsVisible(): boolean {
		return this.configService.get((x) => x.common.loyalty.termsAndConditionsVisible, false);
	}
}
